import {Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output} from '@angular/core';
import {ConfService} from '../conf.service';
import {MatSnackBar} from '@angular/material';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AccountInfoService} from '../user/account-info.service';
import {AuthedApiService} from '../authed-api.service';
import {environment} from '../../environments/environment';

declare let $;

class ImageSnippet {
  constructor(public src: string, public file: File) {
  }
}

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss']
})
export class ImageUploadComponent implements OnInit {

  @Input() payload: any;

  files1: any = [];
  loading = false;
  imageURL: string;
  fileDropped = false;
  fileToUpload: any;
  inputData: any;
  imageSelected: any;
  item = {};
  fileName: string;
  folderName: string;
  items: any;
  itemLength: any;
  renderImage: any;
  imageNotAvailableInPartner = false;
  files: any = [];
  logoType: string;
  imageHeight: number;
  imageWidth: number;
  uploadSection: boolean;
  imageDropped = false;
  // uploadSectionOnDrop: boolean;
  imageInput: any;
  urlImage: any;
  partner: any;
  account: any;

  devexFavIcon = '';

  constructor(private confPost: ConfService,
              public accountInfoService: AccountInfoService,
              private authedApi: AuthedApiService,
              private snackBar: MatSnackBar,
              private platform: LeftpanelComponent) { }

  async ngOnInit() {

    this.logoType = this.payload['logoType'];
    this.imageHeight = this.payload['imageHeight'];
    this.imageWidth = this.payload['imageWidth'];
  this.partner = this.accountInfoService.partner;
  this.account = this.accountInfoService.account;

    if (this.platform.settingsData !== null && this.platform.settingsData !== undefined) {
      this.item = this.platform.settingsData['body'][0];
      this.getBrandDetailsFromPartnerSettings();
    } else {
      await this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(response => {
        if (response['body'] && response['body'][0]) {
          this.platform.settingsData = response;
          this.item = response['body'][0];
          this.getBrandDetailsFromPartnerSettings();
        }
      });
    }
  }

  async updateData() {
      this.loading = false;
      this.imageNotAvailableInPartner = false;
      await this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(response => {
          if (response['body'] && response['body'][0]) {
              this.platform.settingsData = response;
              this.item = response['body'][0];
              this.getBrandDetailsFromPartnerSettings();
          }
      }, error => {
          this.loading = true;
      });
  }

  async getS3Files() {
    await this.confPost.getS3Files(this.partner).toPromise().then(data => {
      // this.itemLength = this.items.length;
      if (data) {
        this.items = data;
        for (let i = 0; i < this.items.length; i++) {
          if (this.logoType === 'logoMark' && 'logo.png' in this.items[i]) {
            this.renderImage = this.items[i]['logo.png'];
          } else if (this.logoType === 'brandImage' && 'brandImage.png' in this.items[i]) {
            this.renderImage = this.items[i]['brandImage.png'];
          }
        }
        this.loading = true;
      }
    }, error => {
      this.loading = true;
      this.snackBar.open(error.error.message ? error.error.message : JSON.stringify(error.error), 'Close', {
        duration: 20000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

  getBrandDetailsFromPartnerSettings() {
    if (this.logoType === 'logoMark' && (this.item['logo'] === 'null' || this.item['logo'] === undefined || this.item['logo'] === '' || this.item['logo'] === null)) {
      this.imageNotAvailableInPartner = true;
    } else if (this.logoType === 'brandImage' && (this.item['brand_image'] === 'null' || this.item['brand_image'] === undefined || this.item['brand_image'] === '' || this.item['brand_image'] === null)) {
      this.imageNotAvailableInPartner = true;
    } else if (this.logoType === 'favIcon') {
        for (const environment of this.item['environments']) {
            if (environment['name'] === this.partner) {
                const devex = environment['services'].filter(element => element.name === 'Developer Experience');
                for (const config of devex[0]['configurations']) {
                    if (config && config !== null && config !== undefined) {
                        if (config['name'] === 'Developer Experience') {
                            this.devexFavIcon = config['devex_configurations'] ? config['devex_configurations']['favicon'] ? config['devex_configurations']['favicon'] : '' : '';
                        }
                    }
                }
            }
        }
        if (this.devexFavIcon === '') {
            this.imageNotAvailableInPartner = true;
        }
    }
    if (!this.imageNotAvailableInPartner) {
      this.uploadSection = false;
      if (this.logoType === 'logoMark') {
        this.urlImage = this.item['logo'];
      } else if (this.logoType === 'brandImage') {
          this.urlImage = this.item['brand_image'];
      } else if (this.logoType === 'favIcon') {
          this.urlImage = this.devexFavIcon;
      }
    } else {
      this.uploadSection = true;
    }
    // this.getS3Files();
    this.loading = true;
  }

  uploadToS32(logoType, filename, partner, image, folder) {
    this.loading = false;
    this.confPost.uploadS3File(filename, partner, image, folder).subscribe(
        (res) => {
          // this.platform.openSnackBar('Uploaded successfully', 'Success', {
          //   duration: 2000,
          //   verticalPosition: 'top',
          //   horizontalPosition: 'center'
          // });
          if (this.logoType === 'logoMark') {
            this.item['logo'] = 'https://apiplatformio.s3.amazonaws.com/' + partner + '/' + folder + '/' + filename;
            this.renderImage = this.item['logo'];
          } else if (this.logoType === 'brandImage') {
            this.item['brand_image'] = 'https://apiplatformio.s3.amazonaws.com/' + partner + '/' + folder + '/' + filename;
            this.renderImage = this.item['brand_image'];
          } else if (this.logoType === 'favIcon') {
              this.devexFavIcon = 'https://apiplatformio.s3.amazonaws.com/' + partner + '/' + folder + '/' + filename;
          }
          if (this.imageNotAvailableInPartner) {
              if (this.logoType === 'logoMark' || this.logoType === 'brandImage') {
                  this.updatePartner();
              } else if (this.logoType === 'favIcon') {
                  this.updatePartnerDevex();
              }
          }
        },
        (err) => {
          this.loading = true;
          this.platform.openSnackBar('Error occurred while upload, Please try after sometime', 'Error', {
            duration: 2000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          this.uploadSection = true;
        });
  }

  uploadToS3(image, foldername) {
        this.loading = true;

        const formData = new FormData();
          formData.append('file', image);
          formData.append('folder', foldername);

        this.authedApi.postCoreApiMultipart(environment.coreAPI.uploadFiletoS3.name, environment.coreAPI.uploadFiletoS3.version, formData).subscribe(
            res => {
                if (res) {
                    if (this.logoType === 'logoMark') {
                        this.item['logo'] = res['s3URL'];
                        this.urlImage = this.item['logo'];
                        this.renderImage = this.item['logo'];
                    } else if (this.logoType === 'brandImage') {
                        this.item['brand_image'] = res['s3URL'];
                        this.urlImage = this.item['brand_image'];
                        this.renderImage = this.item['brand_image'];
                    } else if (this.logoType === 'favIcon') {
                        this.devexFavIcon = res['s3URL'];
                        this.urlImage = this.devexFavIcon;
                    }
                    this.loading = false;
                    if (this.imageNotAvailableInPartner) {
                        if (this.logoType === 'logoMark' || this.logoType === 'brandImage') {
                            this.updatePartner();
                        } else if (this.logoType === 'favIcon') {
                            this.updatePartnerDevex();
                        }
                    }
                }
            },
            (err) => {
                this.loading = true;
                this.platform.openSnackBar('Error occurred while upload, Please try after sometime', 'Error', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.uploadSection = true;
            });
    }

  previewImage(imageInput: any) {
    const file: File = imageInput.files[0];
    const self = this;
    // const file: File = imageInput;
    if (file !== undefined) {
      const reader = new FileReader();
      const logoMarkInput = $('#' + this.logoType)[0];
      reader.onload = function (event: any) {
        if ( self.logoType === 'logoMark') {
          $('#test').attr('src', event.target.result);
        } else if ( self.logoType === 'brandImage') {
          $('#test1').attr('src', event.target.result);
        } else if ( self.logoType === 'favIcon') {
            $('#test2').attr('src', event.target.result);
        }
      };
      reader.readAsDataURL(file);
      this.imageInput = imageInput;
      self.uploadSection = false;
        const list = new DataTransfer();
        list.items.add(file);

        const myFileList = list.files;
      const inputElement: HTMLInputElement = document.getElementById(this.logoType) as HTMLInputElement;
      inputElement.files = null;
    }
  }

  previewOnDrop(imageInput: any) {
      this.imageDropped = true;
    const file: File = imageInput;
    // const file: File = imageInput;
    if (file !== undefined) {
      const self = this;
      const reader = new FileReader();
      const logoMarkInput = $('#' + this.logoType)[0];
      reader.onload = function (event: any) {
        if ( self.logoType === 'logoMark') {
          $('#test').attr('src', event.target.result);
        } else if ( self.logoType === 'brandImage') {
          $('#test1').attr('src', event.target.result);
        } else if ( self.logoType === 'favIcon') {
            $('#test2').attr('src', event.target.result);
        }
      };
      reader.readAsDataURL(file);
      this.imageInput = imageInput;
      this.uploadSection = false;
    }
  }

    processImageOnDrop(imageInput: any) {
        const file: File = imageInput;
        // const file: File = imageInput;
        if (file !== undefined) {
            const self = this;
            const reader = new FileReader();
            const logoMarkInput = $('#' + this.logoType)[0];
            reader.onload = function (event: any) {
                // $('#test').attr('src', event.target.result);
                const image = new Image();
                image.src = event.target.result;
                image.onload = function () {
                    const height = image.height;
                    const width = image.width;
                    if (height > self.imageHeight || width > self.imageWidth) {
                        alert('Height should not exceed ' + self.imageHeight + 'px and Width should not exceed '  + self.imageWidth + 'px.');
                        self.uploadSection = true;
                        return false;
                    } else {
                        self.imageSelected = new ImageSnippet(event.target.result, file);
                        self.uploadToS3(self.imageSelected.file, self.folderName);
                        // self.uploadToS3(self.logoType, self.fileName, localStorage.getItem('partner'), self.imageSelected.file, self.folderName);
                    }
                };
            };
            reader.readAsDataURL(file);
        }
    }

  processImage(imageInput: any) {
    const file: File = imageInput.files[0];
    // const file: File = imageInput;
    if (file !== undefined) {
      const self = this;
      const reader = new FileReader();
      const logoMarkInput = $('#' + this.logoType)[0];
      reader.onload = function (event: any) {
        // $('#test').attr('src', event.target.result);
        const image = new Image();
        image.src = event.target.result;
        image.onload = function () {
          const height = image.height;
          const width = image.width;
          if (height > self.imageHeight || width > self.imageWidth) {
            alert('Height should not exceed ' + self.imageHeight + 'px and Width should not exceed '  + self.imageWidth + 'px.');
            self.uploadSection = true;
            return false;
          } else {
            self.imageSelected = new ImageSnippet(event.target.result, file);
            // self.uploadToS3(self.logoType, self.fileName, localStorage.getItem('partner'), self.imageSelected.file, self.folderName);
              self.uploadToS3(self.imageSelected.file, self.folderName);
          }
        };
      };
      reader.readAsDataURL(file);
    }
  }

  removeLogo() {
    if (this.logoType === 'logoMark') {
      this.item['logo'] = '';
    } else if (this.logoType === 'brandImage') {
      this.item['brand_image'] = '';
    }

    if (this.logoType === 'logoMark' || this.logoType === 'brandImage') {
        this.deletePartner();
    } else if (this.logoType === 'favIcon') {
        this.devexFavIcon = '';
        this.updatePartnerDevex(false);
    }
  }

  hasUploadPermissions() {
        if (this.logoType === 'logoMark') {
            return this.accountInfoService.hasPermission('UPLOAD_LOGO_MARK_BRANDING');
        } else if (this.logoType === 'brandImage') {
            return this.accountInfoService.hasPermission('UPLOAD_BRAND_IMAGE_BRANDING');
        } else if (this.logoType === 'favIcon') {
            return this.accountInfoService.hasPermission('UPLOAD_BRAND_IMAGE_BRANDING');
        }
  }

    hasDeletePermissions() {
        if (this.logoType === 'logoMark') {
            return this.accountInfoService.hasPermission('DELETE_LOGO_MARK_BRANDING');
        } else if (this.logoType === 'brandImage') {
            return this.accountInfoService.hasPermission('DELETE_BRAND_IMAGE_BRANDING');
        } else if (this.logoType === 'favIcon') {
            return this.accountInfoService.hasPermission('DELETE_BRAND_IMAGE_BRANDING');
        }
    }

    async uploadLogoOnDrop() {
        if (this.logoType === 'logoMark') {
            this.fileName = 'logo.png';
            this.folderName = 'LogoMark';
        } else if (this.logoType === 'brandImage') {
            this.fileName = 'brandImage.png';
            this.folderName = 'BrandImage';
        } else if (this.logoType === 'favIcon') {
            this.fileName = 'favicon.ico';
            this.folderName = 'FavIcon';
        }
        await this.processImageOnDrop(this.imageInput);

    }

  async uploadLogo() {
    if (this.logoType === 'logoMark') {
      this.fileName = 'logo.png';
      this.folderName = 'LogoMark';
    } else if (this.logoType === 'brandImage') {
      this.fileName = 'brandImage.png';
      this.folderName = 'BrandImage';
    } else if (this.logoType === 'favIcon') {
        this.fileName = 'favicon.ico';
        this.folderName = 'FavIcon';
    }
    await this.processImage(this.imageInput);

  }

    patchConfiguration(partner, account, version, entity, id, payload) {
        return new Promise((resolve, reject) => {
            this.platform.patchEntityData(partner, account, version, entity, id, payload).then(resp => {
                resolve('success');
            }, error => {
                reject(error);
            });
        });
    }

  updatePartnerDevex(toBeUploaded = true) {
      let index = 0;
      this.loading = false;
      for (const env1 of this.item['environments']) {
          if (env1 && env1 !== null && env1 !== undefined) {
              this.confPost.getSettingsV2CRUD(env1['name'], env1['name'], false).subscribe(async response1 => {
                  let updateFlag = false;
                  if (response1 && response1['body'] && response1.status === 200) {
                      for (const env2 of response1['body'][0]['environments']) {
                          if (env2 && env2 !== null && env2 !== undefined) {
                              const timeService = env2['services'].filter(element => element.name === 'Developer Experience');
                              if (timeService.length > 0) {
                                  for (let i = 0; i < timeService[0]['configurations'].length; i++) {
                                      const config = timeService[0]['configurations'][i];
                                      if (config && config !== null && config !== undefined) {
                                          if (config['name'] === 'default') {
                                              if (!timeService[0]['configurations'][i]['devex_configurations']) {
                                                  timeService[0]['configurations'][i]['devex_configurations'] = {};
                                              }
                                              timeService[0]['configurations'][i]['devex_configurations']['favicon'] = this.devexFavIcon;
                                              updateFlag = true;
                                          }
                                      }
                                  }
                              }
                          }
                      }
                      if (updateFlag) {
                          await this.patchConfiguration('services', 'services', 'v2', 'settings', response1['body'][0]['id'], response1['body'][0]).then(resp => {
                              index += 1;
                              if (index === this.item['environments'].length) {
                                  this.updateData();
                                  if (toBeUploaded) {
                                      this.platform.openSnackBar('Favicon uploaded successfully.', 'Success', {
                                          duration: 4000,
                                          verticalPosition: 'top',
                                          horizontalPosition: 'center'
                                      });
                                  } else {
                                      this.platform.openSnackBar('Favicon deleted successfully.', 'Success', {
                                          duration: 4000,
                                          verticalPosition: 'top',
                                          horizontalPosition: 'center'
                                      });
                                  }
                              }
                          }, error => {
                              index += 1;
                              this.loading = true;
                              this.platform.openSnackBar('Error while updating favicon configurations for ' + response1['body'][0]['partner'] + '. Please contact administrator.', 'Error', {
                                  duration: 4000,
                                  verticalPosition: 'top',
                                  horizontalPosition: 'center'
                              });
                          });
                      } else {
                          index += 1;
                      }
                  }
              }, error => {
                  this.loading = true;
                  this.platform.openSnackBar('Unable to upload favicon. Please try again later.', 'Error', {
                      duration: 4000,
                      verticalPosition: 'top',
                      horizontalPosition: 'center'
                  });
              });
          } else {
              this.loading = true;
              this.platform.openSnackBar('Unable to upload favicon. Please try again later.', 'Error', {
                  duration: 4000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
              });
          }
      }
  }

  async updatePartner() {
    const noOfEnvironments = this.item['environments'].length;
    let count = 0;
    const payload = {
      logo: this.item['logo'],
      brand_image: this.item['brand_image']
    };
    this.item['environments'].forEach(environment => {
      this.confPost.getSettingsV2CRUD(environment['name'], environment['name'], false).subscribe(response => {
        if (response['body'] && response['body'][0]) {
          this.confPost.patchEntityData('services', 'services', 'v2', 'settings', response['body'][0]['id'], payload).subscribe(response => {
            count += 1;
            if (count === noOfEnvironments) {
                this.platform.openSnackBar(this.folderName + ' uploaded successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
              this.uploadSection = false;
              // location.reload();
                this.updateData();
            }
          }, error => {
              this.loading = true;
            this.platform.openSnackBar(error.error.message ? error.error.message : JSON.stringify(error.error), 'Close', {
              duration: 20000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
              this.platform.openSnackBar(error.error.message ? error.error.message : JSON.stringify(error.error), 'Close', {
                  duration: 5000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
              });
          });
        }
      }, error => {
          this.loading = true;
          this.platform.openSnackBar(error.error.message ? error.error.message : JSON.stringify(error.error), 'Close', {
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
          });
      });
      this.uploadSection = true;
    });
  }

  async deletePartner() {
    const noOfEnvironments = this.item['environments'].length;
    let count = 0;
    const payload = {
      logo: this.item['logo'],
      brand_image: this.item['brand_image']
    };
    this.item['environments'].forEach(environment => {
      this.confPost.getSettingsV2CRUD(environment['name'], environment['name'], false).subscribe(response => {
        if (response['body'] && response['body'][0]) {
          this.confPost.patchEntityData('services', 'services', 'v2', 'settings', response['body'][0]['id'], payload).subscribe(response => {
            count += 1;
            if (count === noOfEnvironments) {
                this.platform.openSnackBar('Deleted successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
              this.uploadSection = true;
              // location.reload();
                this.updateData();
            }
          }, error => {
              this.platform.openSnackBar('Error while data onboard. Please try after sometime', 'Error', {
                  duration: 5000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
              });
          });
        }
      }, error => {
          this.platform.openSnackBar('Error while data onboard. Please try after sometime', 'Error', {
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
          });
      });
    });
  }

  onSelect(event) {
    if (this.files.length < 1) {
      this.files.push(...event.addedFiles);
      // event.source._fileInput.nativeElement.files.push(event.addedFiles);
    }

    if (this.files.length === 1) {
      this.fileDropped = true;
      this.fileToUpload = event.addedFiles['0'];
      this.inputData = event.source._fileInput;
    } else {
      this.fileDropped = false;
    }
  }

  uploadFile1(event) {
    this.previewOnDrop(event[0]);
  }

}

